export const spezie = [
  {
    id: 1,
    nome: 'Curcuma Biologica',
    categoria: 'Spezie Bio',
    descrizione: 'Curcuma in polvere da agricoltura biologica certificata',
    prezzo: '8.90',
    immagine: 'https://public.readdy.ai/ai/img_res/44e7b2d5739a2fc6754dea0b492ed2f8.jpg',
    disponibile: true
  },
  {
    id: 2,
    nome: 'Zenzero in Polvere Bio',
    categoria: 'Spezie Bio',
    descrizione: 'Zenzero macinato finemente, aroma intenso e naturale',
    prezzo: '7.50',
    immagine: 'https://readdy.ai/api/search-image?query=organic%20ginger%20powder%20in%20premium%20glass%20container%20on%20white%20marble%20countertop%20with%20fresh%20ginger%20slices%2C%20minimalist%20elegant%20product%20shot%20with%20soft%20shadows%20and%20clean%20white%20background%2C%20professional%20food%20photography&width=400&height=500&seq=prod2&orientation=portrait',
    disponibile: true
  },
  {
    id: 3,
    nome: 'Cannella di Ceylon Bio',
    categoria: 'Spezie Bio',
    descrizione: 'Cannella pregiata di Ceylon, dolce e aromatica',
    prezzo: '9.90',
    immagine: 'https://readdy.ai/api/search-image?query=organic%20ceylon%20cinnamon%20sticks%20in%20elegant%20glass%20jar%20on%20white%20marble%20surface%20with%20cinnamon%20powder%20scattered%20artistically%2C%20minimalist%20product%20photography%20with%20soft%20natural%20light%20and%20clean%20white%20background%2C%20premium%20food%20styling&width=400&height=500&seq=prod3&orientation=portrait',
    disponibile: true
  },
  {
    id: 4,
    nome: 'Pepe Nero Biologico',
    categoria: 'Spezie Bio',
    descrizione: 'Pepe nero in grani interi, sapore intenso e piccante',
    prezzo: '6.90',
    immagine: 'https://readdy.ai/api/search-image?query=organic%20black%20peppercorns%20in%20premium%20glass%20container%20on%20white%20marble%20surface%20with%20scattered%20peppercorns%2C%20minimalist%20elegant%20product%20photography%20with%20soft%20lighting%20and%20clean%20white%20background%2C%20professional%20food%20styling&width=400&height=500&seq=prod4&orientation=portrait',
    disponibile: true
  },
  {
    id: 5,
    nome: 'Paprika Dolce Bio',
    categoria: 'Spezie Bio',
    descrizione: 'Paprika dolce da peperoni biologici selezionati',
    prezzo: '7.90',
    immagine: 'https://readdy.ai/api/search-image?query=organic%20sweet%20paprika%20powder%20in%20elegant%20glass%20jar%20on%20white%20marble%20countertop%20with%20red%20bell%20peppers%2C%20minimalist%20product%20shot%20with%20soft%20natural%20lighting%20and%20clean%20white%20background%2C%20premium%20food%20photography%20style&width=400&height=500&seq=prod5&orientation=portrait',
    disponibile: true
  },
  {
    id: 6,
    nome: 'Cumino Biologico',
    categoria: 'Spezie Bio',
    descrizione: 'Semi di cumino biologici, aroma caldo e terroso',
    prezzo: '6.50',
    immagine: 'https://readdy.ai/api/search-image?query=organic%20cumin%20seeds%20in%20premium%20glass%20container%20on%20white%20marble%20surface%20with%20scattered%20seeds%2C%20minimalist%20elegant%20product%20photography%20with%20soft%20shadows%20and%20clean%20white%20background%2C%20professional%20food%20styling&width=400&height=500&seq=prod6&orientation=portrait',
    disponibile: true
  },
  {
    id: 13,
    nome: 'Zafferano Biologico Premium',
    categoria: 'Spezie Bio Elite',
    descrizione: 'Zafferano biologico di altissima qualità, raccolto a mano e selezionato con cura. L\'oro rosso della cucina italiana, dal sapore inconfondibile e dalle proprietà uniche',
    prezzo: '29.90',
    immagine: 'https://readdy.ai/api/search-image?query=premium%20organic%20saffron%20threads%20in%20luxurious%20crystal%20glass%20jar%20on%20white%20marble%20surface%20with%20golden%20saffron%20stigmas%20scattered%20artistically%20beside%20it%2C%20elegant%20minimalist%20product%20photography%20with%20soft%20dramatic%20lighting%20and%20clean%20white%20background%2C%20ultra%20high%20quality%20professional%20food%20styling%20showcasing%20the%20red%20gold%20spice%2C%20refined%20and%20sophisticated%20composition&width=400&height=500&seq=prod13elite&orientation=portrait',
    disponibile: true
  }
];

export const biscotti = [
  {
    id: 7,
    nome: 'Biscotti allo Zenzero',
    categoria: 'Biscotti Bio',
    descrizione: 'Biscotti croccanti con zenzero biologico, perfetti per tisane',
    prezzo: '5.90',
    immagine: 'https://readdy.ai/api/search-image?query=organic%20ginger%20cookies%20arranged%20on%20white%20ceramic%20plate%20with%20tea%20cup%2C%20minimalist%20food%20photography%20with%20soft%20natural%20lighting%20and%20clean%20beige%20background%2C%20artisan%20biscuits%20with%20visible%20texture%20and%20golden%20brown%20color%2C%20professional%20styling&width=400&height=500&seq=prod7&orientation=portrait',
    disponibile: true
  },
  {
    id: 8,
    nome: 'Biscotti alla Cannella',
    categoria: 'Biscotti Bio',
    descrizione: 'Deliziosi biscotti speziati alla cannella biologica',
    prezzo: '5.90',
    immagine: 'https://readdy.ai/api/search-image?query=organic%20cinnamon%20cookies%20on%20elegant%20white%20plate%20with%20cinnamon%20sticks%20beside%2C%20minimalist%20product%20photography%20with%20soft%20lighting%20and%20clean%20beige%20background%2C%20artisan%20biscuits%20with%20rustic%20texture%2C%20professional%20food%20styling&width=400&height=500&seq=prod8&orientation=portrait',
    disponibile: true
  },
  {
    id: 9,
    nome: 'Biscotti al Limone Bio',
    categoria: 'Biscotti Bio',
    descrizione: 'Biscotti fragranti al limone biologico, ideali per il tè',
    prezzo: '5.50',
    immagine: 'https://readdy.ai/api/search-image?query=organic%20lemon%20cookies%20arranged%20on%20white%20ceramic%20dish%20with%20fresh%20lemon%20slices%2C%20minimalist%20food%20photography%20with%20soft%20natural%20light%20and%20clean%20beige%20background%2C%20golden%20biscuits%20with%20delicate%20texture%2C%20professional%20styling&width=400&height=500&seq=prod9&orientation=portrait',
    disponibile: true
  },
  {
    id: 10,
    nome: 'Biscotti Integrali Bio',
    categoria: 'Biscotti Bio',
    descrizione: 'Biscotti integrali con farina biologica e miele',
    prezzo: '6.50',
    immagine: 'https://readdy.ai/api/search-image?query=organic%20whole%20wheat%20cookies%20on%20white%20plate%20with%20honey%20jar%20beside%2C%20minimalist%20product%20photography%20with%20soft%20lighting%20and%20clean%20beige%20background%2C%20rustic%20artisan%20biscuits%20with%20natural%20texture%2C%20professional%20food%20styling&width=400&height=500&seq=prod10&orientation=portrait',
    disponibile: true
  },
  {
    id: 12,
    nome: 'Biscotti alla Vaniglia Bio',
    categoria: 'Biscotti Bio',
    descrizione: 'Biscotti delicati alla vaniglia bourbon biologica',
    prezzo: '6.50',
    immagine: 'https://readdy.ai/api/search-image?query=organic%20vanilla%20cookies%20arranged%20on%20white%20plate%20with%20vanilla%20pods%20beside%2C%20minimalist%20product%20photography%20with%20soft%20lighting%20and%20clean%20beige%20background%2C%20delicate%20artisan%20biscuits%20with%20smooth%20texture%2C%20professional%20food%20styling&width=400&height=500&seq=prod12&orientation=portrait',
    disponibile: true
  }
];